import { Chip } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import useAPI from "../../../../../api/hooks/useAPI";
import useColors from "../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../components/CustomTooltip";
import iconMapping from "../../../../../icons/IconMapping";
import { isComplexEntityType } from "../../../../../utils/utils";

const IndividualEntityChip = ({
  entity,
  handleEntityClick = null,
  sx = {},
}) => {
  const [searchParams, setSearchParams] = useSearchParams("");
  const { trackEvent } = useAPI();
  const colors = useColors();

  const subtype = entity?.subtype || null;
  let Icon =
    iconMapping[subtype] ||
    iconMapping[entity?.entity_type] ||
    iconMapping["Internet"];

  // Check if this is a complex entity type (can be clicked) or simple entity type (non-clickable)
  const isClickable = isComplexEntityType(entity?.entity_type);

  const handleClick = (event) => {
    // Don't handle click for simple entities
    if (!isClickable) {
      return;
    }

    event.stopPropagation();

    // Track the click
    trackEvent(
      `User clicked on entity ${entity?.entity_type} - ${entity?.display_name}`
    );

    // Open entity drawer by setting the entity param
    if (entity?.entity_id) {
      searchParams.set("entity", encodeURIComponent(entity.entity_id));
      setSearchParams(searchParams.toString());
    }

    // Call custom handler if provided
    if (handleEntityClick) {
      handleEntityClick(entity);
    }
  };

  const displayName =
    entity?.display_name ||
    entity?.original_unique_id ||
    entity ||
    "Unknown Entity";

  const tooltipTitle = isClickable
    ? `View ${displayName} details`
    : displayName;

  return (
    <CustomToolTip title={tooltipTitle} placement="top">
      <Chip
        label={displayName}
        onClick={isClickable ? handleClick : undefined}
        icon={<Icon style={{ color: colors.text_primary, width: "20px" }} />}
        style={{
          background: colors.entity_chip_enabled_fill,
          borderRadius: "8px",
          fontSize: "12px",
          color: colors.text_primary,
          boxShadow: colors.entity_chip_enabled_shadow,
          height: "32px",
          paddingLeft: "4px",
          cursor: isClickable ? "pointer" : "default",
          ...sx,
        }}
      />
    </CustomToolTip>
  );
};

export default IndividualEntityChip;
